import { type ApolloCache, ApolloClient } from "@apollo/client";
import {
    type GetLensListV2QueryVariables,
    type GetCachedLensListV2Query,
    getCachedLensListV2,
    type GetLensListV2Query,
    getLensListV2,
    type GetCachedLensListV2QueryVariables,
} from "../api/query";
import { LensesOperationsV2 } from "../api/cache";

export class LensesRepositoryV2 {
    public constructor(private apolloClient: ApolloClient<any>) {}

    public static initDefaults(cache: ApolloCache<any>) {
        cache.writeQuery<Partial<GetCachedLensListV2Query>, GetCachedLensListV2QueryVariables>({
            query: getCachedLensListV2,
            data: {
                __typename: "Query",
                getLensListV2: {
                    lensesWithConnections: [],
                    cursor: "",
                    __typename: "LensListWithConnections",
                },
            },
        });
    }

    public loadLensesToCache(variables: Partial<GetLensListV2QueryVariables>) {
        const lensesCache = this.apolloClient.readQuery<GetCachedLensListV2Query>({
            query: getCachedLensListV2,
        });

        return this.apolloClient
            .query<GetLensListV2Query, GetLensListV2QueryVariables>({
                query: getLensListV2,
                variables: {
                    limit: variables.limit ?? 10,
                    cursor: lensesCache?.getLensListV2?.cursor ?? "",
                },
                fetchPolicy: "no-cache",
            })
            .then(({ data }) => {
                this.appendToCache(data);
                return data.getLensListV2;
            });
    }

    private appendToCache(data: GetLensListV2Query) {
        const prevData = this.apolloClient.readQuery<GetCachedLensListV2Query>({
            query: getCachedLensListV2,
        });

        this.apolloClient.cache.writeQuery({
            query: getCachedLensListV2,
            data: LensesOperationsV2.concat(prevData ?? ({} as GetCachedLensListV2Query), data),
        });
    }
}
